import InventoryPage from "./InventoryPage";

export default InventoryPage;
